// extracted by mini-css-extract-plugin
export default {"article":"CommunityDetail_article__8ou8k","contents":"CommunityDetail_contents__Sm7mh","main":"CommunityDetail_main__yiRD+","time":"CommunityDetail_time__CMeUx"};